import { useEffect, useState } from 'react';
export var useAudioError = function useAudioError(audioRef) {
  var _useState = useState(null),
      error = _useState[0],
      setError = _useState[1];

  useEffect(function () {
    var listener = function listener(event) {
      var audioElement = event.target;
      setError(audioElement.error);
    };

    var audio = audioRef.current;
    audio.addEventListener('error', listener);
    return function () {
      audio.removeEventListener('error', listener);
    };
  }, [audioRef, setError]);
  return {
    error: error,
    setError: setError
  };
};